export const CHARACTER_LIMITS = {
  prescription: 255,
  sickLeave: 1000,
  findings: 4000,
  recommendations: 4000,
  internalNotes: 4000,
} as const;

export const characterLimitMessage = (template: string, limit: number) =>
  template.replace('XX', limit.toString());

export const exceedsCharacterLimit = (value: string, limit: number) => value.length > limit;
